import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const Era = props => {
  const { deleteEra, era } = props.eraInfo;
  const { mode } = props;
  return (
    <tr>
      <td>{era.id}</td>
      <td>{era.name}</td>
      <td>{era.description}</td>
      <td>{moment(era.created_at).format('MMMM Do YYYY, h:mm:ss a')}</td>
      <td>
        {mode == 'edit' ? (
          <React.Fragment>
            <button className="cus-btn-danger mr-15" onClick={() => deleteEra(era)}>
              Delete
            </button>
            <Link className="cus-btn-primary" to={`/era/edit/${era.id}`}>
              Edit
            </Link>
          </React.Fragment>
        ) : (
          <Link className="cus-btn-primary" to={`/era/view/${era.id}`}>
            View
          </Link>
        )}
      </td>
    </tr>
  );
};

export default Era;
